<template>
  <div class="col d-column">
    <!-- Aporte -->
    <div class="c-grid" v-if="routePath != '/account'">
      <div v-if="provisionsSummary" class="base-card">
        <div class="area-label">
          <label
            >{{ $ml.get("summaryTotalCard") }} <br />
            <span v-if="currency === 'BRL'">{{ $utils.convertMoney(total_initial_value) }}</span>
            <span v-else>{{ $utils.convertDollar(total_initial_value) }}</span>
            </label>
        </div>
        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.075">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="provisionsSummary"
        class="base-card"
        style="background: #e10e71"
      >
        <div class="area-label">
          <label>{{ $ml.get("totalMonthlyPayments") }}</label>
          <br />
          <span v-if="currency === 'BRL'">{{ $utils.convertMoney(total_contract_standard_value) }}</span>
          <span>{{ $utils.convertDollar(total_contract_standard_value) }}</span>
        </div>
        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.075">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="provisionsSummary"
        class="base-card"
        style="background: #bf56f9"
      >
        <div class="area-label">
          <label>{{ $ml.get("totalManagedServices") }}</label>
          <br />
          <span v-if="currency === 'BRL'">{{
            $utils.convertMoney(total_contract_management_value)
          }}</span>
               <span v-else>{{
            $utils.convertDollar(total_contract_management_value)
          }}</span>
        </div>
        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.075">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="provisionsSummary"
        class="base-card"
        style="background: #636363"
      >
        <div class="area-label">
          <label>{{ $ml.get("totalRewardsPaid") }}</label>
          <br />
          <span v-if="currency === 'BRL'">{{ $utils.convertMoney(total_bounty_value) }}</span>
          <span v-else>{{ $utils.convertDollar(total_bounty_value) }}</span>
        </div>
        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.075">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>
      </div>
      <div
        v-if="provisionsSummary"
        class="base-card"
        style="background-color: #7951cd"
      >
        <div class="area-label">
          <label>{{ $ml.get("summaryTotalPgCard") }}</label
          ><br />
          <span v-if="currency === 'BRL'">{{ $utils.convertMoney(total_paid_value) }}</span>
          <span v-else>{{ $utils.convertDollar(total_paid_value) }}</span>
        </div>
        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.075">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>
      </div>
      <div
        v-show="provisionsSummary"
        class="base-card"
        style="background-color: #0000ff90"
      >
        <div class="area-label">
          <label>{{ $ml.get("balance") }}</label
          ><br />
          <span v-if="currency === 'BRL'">{{ $utils.convertMoney(balance_value) }}</span>
          <span v-else>{{ $utils.convertDollar(balance_value) }}</span>
        </div>

        <div class="base-logo">
          <svg width="225" height="90" style="opacity: 0.05">
            <image
              xlink:href="../../../assets/svg/logo.svg"
              width="80"
              height="90"
            />
          </svg>
        </div>

        <div v-show="balance_value > 0" class="gauge-chart">
          <label class="gauge-percentage">{{ balance_percentage }}%</label>
          <canvas id="custom-gauge-chart" />
        </div>
      </div>
    </div>
    <div v-if="vulnerabilitiesChart.series && routePath != '/account'" class="row align-items-center">
      <div class="ml-0 p-0">
        <h4
          class="m-0 p-0 mb-2"
          v-text="$ml.get('bountyAwarded')"
          style="font-size: 1.1rem; font-weight: 500"
        >
          Recompensa Concedida
        </h4>
        <apexchart
          class="ml-0 p-0"
          width="220"
          type="donut"
          :options="vulnerabilitiesChart"
          :series="vulnerabilitiesChart.series"
        ></apexchart>
      </div>
      <div class="col-12 mt-4">
        <h5 class="mt-3" v-text="$ml.get('total')">Total</h5>
        <h5 class="mb-3" v-if="currency === 'BRL'">{{ $utils.convertMoney(vulnerabilitiesTotal) }}</h5>
        <h5 class="mb-3" v-else>{{ $utils.convertDollar(vulnerabilitiesTotal) }}</h5>
        <div class="row mt-1">
          <div class="mr-3">
            <div class="row">
              <Impact impact="impact-critical-billings" class="mt-1 mr-1" />
              <span v-text="$ml.get('critical')"></span>
            </div>
            <h5 class="my-1" v-if="currency === 'BRL'">
              {{ $utils.convertMoney(vulnerabilitiesChart.series[0] ?? 0) }}
            </h5>
            <h5 class="my-1" v-else>
              {{ $utils.convertDollar(vulnerabilitiesChart.series[0] ?? 0) }}
            </h5>
          </div>
          <div class="mr-3">
            <div class="row">
              <Impact impact="impact-high-billings" class="mt-1 mr-1" />
              <span v-text="$ml.get('high')"></span>
            </div>
            <h5 class="my-1" v-if="currency === 'BRL'">
              {{ $utils.convertMoney(vulnerabilitiesChart.series[1] ?? 0) }}
            </h5>
            <h5 class="my-1" v-else>
              {{ $utils.convertDollar(vulnerabilitiesChart.series[1] ?? 0) }}
            </h5>
          </div>
          <div class="mr-3">
            <div class="row">
              <Impact impact="impact-medium-billings" class="mt-1 mr-1" />
              <span v-text="$ml.get('medium')"></span>
            </div>
            <h5 class="my-1" v-if="currency === 'BRL'">
              {{ $utils.convertMoney(vulnerabilitiesChart.series[2] ?? 0) }}
            </h5>
            <h5 class="my-1" v-else>
              {{ $utils.convertDollar(vulnerabilitiesChart.series[2] ?? 0) }}
            </h5>
          </div>
          <div class="mr-3">
            <div class="row">
              <Impact impact="impact-low-billings" class="mt-1 mr-1" />
              <span v-text="$ml.get('low')"></span>
            </div>
            <h5 class="my-1" v-if="currency === 'BRL'">
              {{ $utils.convertMoney(vulnerabilitiesChart.series[3] ?? 0) }}
            </h5>
            <h5 class="my-1" v-else>
              {{ $utils.convertDollar(vulnerabilitiesChart.series[3] ?? 0) }}
            </h5>
          </div>
        </div>
      </div>
    </div>
    <hr v-if="routePath != '/account'" />
    <b-card>
      <div
        v-show="tabDetailsShow"
        class="row justify-content-between align-items-center"
      >
        <div class="row col-24 col-md-18">
          <div class="col-24 col-md-14 py-2">
            <div class="mr-2">
              <multiselect
                v-model="type"
                label="name"
                :custom-label="nameLang"
                :options="itensType"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                @input="changeDados()"
                :placeholder="$ml.get('type')"
              >
              </multiselect>
            </div>
          </div>

          <div class="col-24 col-md-6 py-2">
            <div class="mr-2">
              <multiselect
                v-model="status"
                label="name"
                :custom-label="nameLang"
                :options="itensSituation"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
                @input="changeDados()"
                :placeholder="$ml.get('status')"
              >
              </multiselect>
            </div>
          </div>
        </div>

        <label class="pointer m-0">
          <a @click="downloadCSVData()" :disabled="loadingBtn" class="pr-1">
            {{ $ml.get("exportInCsv") }}
          </a>
        </label>
      </div>

      <div class="row d-flex justify-content-between align-items-center">
        <div class="col-12 col-md-6 py-2">
          <div class="input-group">
            <b-form-datepicker
              class="datepicker m-0 p-0 mr-2"
              id=""
              label-help=""
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              :locale="$ml.get('ln')"
              today-button
              reset-button
              close-button
              :label-today-button="$ml.get('today')"
              :label-reset-button="$ml.get('reset')"
              :label-close-button="$ml.get('exit')"
              v-model="initialDate"
              :placeholder="$ml.get('start')"
            >
            </b-form-datepicker>
          </div>
        </div>

        <div class="col-12 col-md-6 py-2">
          <div class="input-group mr-2">
            <b-form-datepicker
              class="datepicker m-0 p-0 mr-2"
              id=""
              label-help=""
              :date-format-options="{
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
              }"
              :locale="$ml.get('ln')"
              today-button
              reset-button
              close-button
              :label-today-button="$ml.get('today')"
              :label-reset-button="$ml.get('reset')"
              :label-close-button="$ml.get('exit')"
              v-model="finalDate"
              :placeholder="$ml.get('end')"
            >
            </b-form-datepicker>
          </div>
        </div>
        <div v-show="!tabDetailsShow" class="col-9">
          <label class="title-range" for="range-2">
            {{ $ml.get("projectedValueLabel") }}: {{ sliderValue }}</label
          >
          <b-form-input
            id="range-2"
            v-model="sliderValue"
            type="range"
            min="0"
            max="20"
            @change="handleSliderInput"
          ></b-form-input>
        </div>
        <div v-show="tabDetailsShow" class="input-group col-12 col-md-6 py-2">
          <input
            class="form-control filterInput"
            v-model.number="invoiceNumberSearch"
            placeholder="NF"
            aria-label="Search"
            type="number"
            style="border-right: none"
            @input="searchTime()"
          />
          <div class="input-group-append mr-2">
            <div class="input-group-text" style="background-color: #fff">
              <svg width="20" height="20" class="mt-1">
                <image
                  xlink:href="../../../assets/icons/search_s.svg"
                  width="18"
                  height="18"
                />
              </svg>
            </div>
          </div>
        </div>
        <div v-show="tabDetailsShow" class="input-group col-12 col-md-6 py-2">
          <input
            class="form-control"
            v-model="reportSearch"
            :placeholder="$ml.get('report')"
            aria-label="Search"
            type="text"
            style="border-right: none"
            @input="searchTime()"
          />
          <div class="input-group-append">
            <div class="input-group-text" style="background-color: #fff">
              <svg width="20" height="20" class="mt-1">
                <image
                  xlink:href="../../../assets/icons/search_s.svg"
                  width="18"
                  height="18"
                />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <hr />

      <div class="card">
        <b-tabs
          tabs
          v-if="
            ['owner', 'administrator'].includes(
              this.$store.getters['getUser'].role,
            )
          "
        >
          <b-tab
            :title="this.$ml.get('summary')"
            @click="tabDetailsShow = false"
            style="background: #f7f8f9"
          >
            <div class="card-chart col-23">
              <canvas id="chart-main" />
            </div>
          </b-tab>
          <b-tab
            :title="this.$ml.get('detailsNF')"
            @click="tabDetailsShow = true"
          >
            <table>
              <thead>
                <tr>
                  <th class="col-2">NF</th>
                  <th class="col-4" v-text="$ml.get('issued')"></th>
                  <th class="col-4" v-text="$ml.get('accurate')"></th>
                  <th class="col-4" v-text="$ml.get('received')"></th>
                  <th class="col-6" v-text="$ml.get('type')"></th>
                  <th class="col-4" v-text="$ml.get('status')"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-show="!itensPayment.length" class="loading">
                  <div v-if="loading" class="c-loader m-3"></div>
                  <h6
                    v-else
                    class="col d-flex justify-content-center p-3"
                    v-text="$ml.get('noPaymentsFound')"
                  >
                    Nenhum pagamento encontrado
                  </h6>
                </tr>
                <tr v-for="(item, index) in itensPayment" :key="index">
                  <div class="col-24">
                    <div class="p-0 m-0">
                      <div
                        v-b-toggle="'accordion_invoice-' + index"
                        variant="info"
                        class="d-flex align-items-center"
                      >
                        <td class="col-2">{{ item.number }}<br /></td>
                        <td class="col-4">
                          {{ $utils.formatDataShort(item.dEmi) }}<br />
                        </td>
                        <td class="col-4">
                          <span v-if="currency === 'BRL'">{{ convertMoney(item.value ?? 0) }}</span>
                          <span v-else>{{ $utils.convertDollar(item.value ?? 0) }}</span>
                        </td>
                        <td class="col-4">
                          {{
                            item.payment_date === "--/--/----"
                              ? "--/--/----"
                              : $utils.formatDataShort(item.payment_date)
                          }}<br />
                        </td>
                        <td class="col-6">
                          <div class="">
                            <span
                              v-if="item.type.includes('report_payment')"
                              class="badge badge-secondary p-1"
                              >Bounties</span
                            >

                            <span
                              v-if="item.type.includes('standard')"
                              class="badge badge-secondary p-1 mx-1"
                              >{{ $ml.get("monthlyPayment") }}</span
                            >

                            <span
                              v-if="item.type.includes('program_management')"
                              class="badge badge-secondary p-1 mx-1 my-1"
                              >{{ $ml.get("program_management") }}</span
                            >
                          </div>
                        </td>

                        <td class="col-4 row justify-content-between">
                          <div class="">
                            <span
                              v-show="item.status == 'pending'"
                              class="badge badge-warning p-1"
                              v-text="$ml.get('pending')"
                              >Pendente</span
                            >
                            <span
                              v-show="item.status == 'done'"
                              class="badge badge-success p-1"
                              v-text="$ml.get('done')"
                              >Pago</span
                            >
                          </div>
                          <span
                            class="when-opened"
                            v-if="
                              item.report_payments.length ||
                              item.monthly_payments.length
                            "
                          >
                            <img
                              src="../../../assets/icons/angle-right_black.svg"
                              class="ico-16 angle-right"
                            />
                          </span>
                        </td>
                      </div>
                    </div>
                    <b-collapse
                      v-if="
                        item.report_payments.length ||
                        item.monthly_payments.length
                      "
                      :id="'accordion_invoice-' + index"
                    >
                      <div
                        v-if="item.extractItem.length"
                        class="card-header mx-0 px-0 pb-0"
                      >
                        <div
                          v-for="(itemExtract, index) in item.extractItem"
                          :key="index"
                          class="reportItem"
                        >
                          <div
                            class="row my-2 px-3"
                            style="background: #fafafa"
                          >
                            <h5
                              class="pt-1"
                              v-if="
                                item.extractItem[index - 1]?.date.getMonth() !=
                                itemExtract.date.getMonth()
                              "
                            >
                              {{ $ml.get(month[itemExtract.date.getMonth()]) }}
                            </h5>
                            <h5
                              class="pl-1 pt-1"
                              v-if="
                                item.extractItem[
                                  index - 1
                                ]?.date.getFullYear() !=
                                itemExtract.date.getFullYear()
                              "
                            >
                              / {{ itemExtract.date.getFullYear() }}
                            </h5>
                          </div>

                          <div class="p-1 px-3">
                            <div v-if="itemExtract.type == 'bounty'">
                              <div class="row py-2 w-100">
                                <div class="col-1 d-flex align-items-center">
                                  <img
                                    src="../../../assets/icons/payment.png"
                                    class="ico-28"
                                  />
                                </div>

                                <div class="col">
                                  <div class="col-24 pb-1">
                                    <span class="small">
                                      <label>Recompensa paga em:</label>
                                      <a>
                                        {{
                                          $utils.formatDataLong(
                                            itemExtract.date,
                                          )
                                        }}</a
                                      ><br />
                                    </span>
                                  </div>

                                  <router-link
                                    class="col-24 row py-1"
                                    :to="
                                      '/report/details?' + itemExtract.report_id
                                    "
                                  >
                                    <span
                                      class="small badge badge-secondary mr-2"
                                    >
                                      {{ itemExtract.report_id }}
                                    </span>
                                    <a class="mr-2">
                                      {{ itemExtract.report_title }}</a
                                    >
                                    <Impact
                                      class="pt-1"
                                      :impact="
                                        'impact-' + itemExtract.report_severity
                                      "
                                    />
                                  </router-link>

                                  <div class="col-8 pt-1">
                                    <span class="small">
                                      <b>{{ $ml.get("rewardValue") }}</b>
                                      <a
                                        >:
                                        {{
                                        currency === 'BRL' ?  convertMoney(itemExtract.bounty_value) : $utils.convertDollar(itemExtract.bounty_value) 
                                        }}</a
                                      ><br />
                                    </span>
                                  </div>

                                  <div
                                    class="col-24 p-2 border mt-2"
                                    v-for="(
                                      itemRetest, i
                                    ) in itemExtract.retests"
                                    :key="i"
                                  >
                                    <div class="row mt-2">
                                      <span
                                        class="small badge badge-secondary mr-2"
                                      >
                                        {{ itemRetest._id }}
                                      </span>
                                      <a class="mr-2">
                                        <b>Reteste</b> pago em
                                        {{
                                          $utils.formatDataLong(
                                            itemRetest.createdAt,
                                          )
                                        }}</a
                                      >
                                    </div>

                                    <div class="row mt-2">
                                      <span class="small">
                                        <b v-text="$ml.get('platform')"></b>
                                        <a
                                          >:
                                          {{
                                            itemRetest.retest_platform_percentage
                                          }}%
                                        </a>
                                      </span>
                                      <span class="small col-6 px-2">
                                        <b v-text="$ml.get('value')"></b>
                                        <a
                                          >:
                                          {{ currency === 'BRL' ? 
                                            convertMoney(
                                              itemRetest.platform_retest_value,
                                            ) :   $utils.convertDollar(
                                              itemRetest.platform_retest_value,
                                            )
                                          }}</a
                                        >
                                      </span>
                                    </div>

                                    <div class="row mt-2">
                                      <span class="small">
                                        <b v-text="$ml.get('specialist')"></b>
                                        <a
                                          >:
                                          {{
                                            itemRetest.retest_hacker_percentage
                                          }}%
                                        </a>
                                      </span>
                                      <span class="small col-6 px-2">
                                        <b v-text="$ml.get('value')"></b>
                                        <a
                                          >:
                                          {{
                                            currency === 'BRL' ? 
                                            convertMoney(
                                              itemRetest.hacker_retest_value,
                                            ) : $utils.convertDollar(
                                              itemRetest.hacker_retest_value,
                                            )
                                          }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div v-if="itemExtract.type == 'standard'">
                              <div class="row py-2">
                                <div class="row py-2 w-100">
                                  <div class="col-1 d-flex align-items-center">
                                    <img
                                      src="../../../assets/icons/monthly_payment.png"
                                      class="ico-28"
                                    />
                                  </div>

                                  <div class="col">
                                    <div class="col-24 pb-1">
                                      <span class="small">
                                        <label
                                          >Mensalidade
                                          {{ $ml.get(itemExtract.type) }} paga
                                          em:</label
                                        >
                                        <a>
                                          {{
                                            $utils.formatDataLong(
                                              itemExtract.date,
                                            )
                                          }}</a
                                        ><br />
                                      </span>
                                    </div>

                                    <span class="small row">
                                      <b>{{ $ml.get("monthlyFee") }}</b>
                                      <a
                                        >:
                                        {{ currency === 'BRL' ? convertMoney(itemExtract.value) : $utils.convertDollar(itemExtract.value) }}</a
                                      ><br />
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              v-if="itemExtract.type == 'program_management'"
                            >
                              <div class="row py-2">
                                <div class="col-1 d-flex align-items-center">
                                  <img
                                    src="../../../assets/icons/managed.png"
                                    class="ico-28"
                                  />
                                </div>
                                <div class="col">
                                  <span class="small row pb-1">
                                    <a
                                      >Serviço de
                                      {{ $ml.get(itemExtract.type) }} pago em:
                                      {{
                                        $utils.formatDataLong(itemExtract.date)
                                      }}</a
                                    ><br />
                                  </span>

                                  <span class="small row">
                                    <b> Valor de serviço</b>
                                    <a
                                      >:
                                      {{ currency === 'BRL' ? convertMoney(itemExtract.value) : $utils.convertDollar(itemExtract.value)}}</a
                                    ><br />
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="card-header">
                        <h6 class="pb-1">
                          <b>{{ $ml.get("summary") }}</b>
                        </h6>
                        <div class="row">
                          <div class="small col-12 col-sm-5 pb-2 text-summary">
                            <b
                              class="text-left"
                              v-if="monthlyPayment(item.monthly_payments)"
                              >{{ $ml.get("totalMonthlyFees") }}:<br
                            /></b>
                            <b
                              class="text-left"
                              v-if="program_management(item.monthly_payments)"
                              >Total
                              <font class="text-lowercase">{{
                                $ml.get("additionalServices")
                              }}</font
                              >:<br
                            /></b>
                            <b
                              class="text-left"
                              v-if="item.report_payments.length"
                              >{{ $ml.get("totalRewards") }}:<br
                            /></b>
                            <b class="text-left"
                              >{{ $ml.get("totalSum") }}:<br
                            /></b>
                          </div>

                          <div class="small col-12 col-sm-7 pb-2 text-summary">
                            <a
                              class="text-center"
                              v-if="monthlyPayment(item.monthly_payments)"
                            >
                              {{
                                currency === 'BRL' ?
                                convertMoney(
                                  sumMonthly(
                                    monthlyPayment(item.monthly_payments),
                                  ),
                                ) : 
                                $utils.convertDollar(
                                  sumMonthly(
                                    monthlyPayment(item.monthly_payments),
                                  ),
                                )
                              }}<br
                            /></a>
                            <a
                              class="text-center"
                              v-if="program_management(item.monthly_payments)"
                            >
                              {{
                                currency === 'BRL' ?
                                convertMoney(
                                  sumMonthly(
                                    program_management(item.monthly_payments),
                                  ),
                                ) : 
                                $utils.convertDollar(
                                  sumMonthly(
                                    program_management(item.monthly_payments),
                                  ),
                                )
                              }}<br
                            /></a>
                            <a
                              class="text-center"
                              v-if="item.report_payments.length"
                            >
                              {{ currency === 'BRL' ? convertMoney(sumBounty(item.report_payments)) :  $utils.convertDollar(sumBounty(item.report_payments)) }}<br
                            /></a>
                            <a class="text-center text-danger">
                              {{  currency === 'BRL' ? convertMoney(total(item)) :  $utils.convertDollar(total(item))}}<br
                            /></a>
                          </div>

                          <div class="small col-12 col-sm-4 pb-2 text-summary">
                            <b class="text-left"
                              >{{ $ml.get("noteValue") }}:<br
                            /></b>
                            <b class="text-left"
                              >{{ $ml.get("totalSum") }}:<br
                            /></b>
                            <b class="text-left"
                              >{{ $ml.get("balance") }}:<br
                            /></b>
                          </div>

                          <div class="small col-12 col-sm-8 pb-2 text-summary">
                            <a class="text-center">
                              {{ currency === 'BRL' ? convertMoney(item.value) :  $utils.convertDollar(item.value)}}<br
                            /></a>
                            <a class="text-center">
                              {{ currency === 'BRL' ? convertMoney(total(item)) : $utils.convertDollar(total(item))}}<br
                            /></a>
                            <a class="text-center text-danger">
                              {{ currency === 'BRL' ? convertMoney(item.value - total(item)) :  $utils.convertDollar(item.value - total(item)) }}<br
                            /></a>
                          </div>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </tr>
              </tbody>
            </table>

            <div v-show="totalPages > 10 && itensPayment.length" class="p-3">
              <b-pagination
                v-model="page"
                :total-rows="totalPages"
                :per-page="pageSize"
                :prev-text="$ml.get('previous')"
                :next-text="$ml.get('next')"
                align="right"
              >
              </b-pagination>
            </div>
          </b-tab>
        </b-tabs>
      </div>

      <div v-if="selectedTab === 'Summary'" class="card mb-4">
        <!-- <Bounties /> -->
      </div>

      <div v-if="selectedTab === 'Details'" class="card mb-4"></div>
    </b-card>
    <div v-if="summaryPayments.length && !tabDetailsShow" class="card">
      <table>
        <thead>
          <tr>
            <th class="col-4">{{ $ml.get("monthAndyear") }}</th>
            <th class="col-4">{{ $ml.get("contribution") }}</th>
            <th class="col-4">{{ $ml.get("monthlyPayment") }}</th>
            <th class="col-4">{{ $ml.get("managed") }}</th>
            <th class="col-4">{{ $ml.get("rewards") }}</th>
            <th class="col-4">{{ $ml.get("balance") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(summary, index) in displayedItems" :key="index">
            <td class="col-4">
              {{ $ml.get(month[summary.month - 1]) }}/{{ summary.year }}
            </td>
            <td class="col-4">
              {{ currency === 'BRL' ? $utils.convertMoney(summary.data.provision) : $utils.convertDollar(summary.data.provision)}}
            </td>
            <td class="col-4">
              {{currency === 'BRL' ? $utils.convertMoney(summary.data.monthly) : $utils.convertDollar(summary.data.monthly) }}
            </td>
            <td class="col-4">
              {{currency === 'BRL' ? $utils.convertMoney(summary.data.management) : $utils.convertDollar(summary.data.management)}}
            </td>
            <td class="col-4">
              {{ currency === 'BRL' ?  $utils.convertMoney(summary.data.bounty) : $utils.convertDollar(summary.data.bounty)}}
            </td>
            <td class="col-4">
              {{  currency === 'BRL' ?
                $utils.convertMoney(
                  summary.data.provision -
                    summary.data.monthly -
                    summary.data.management -
                    summary.data.bounty,
                )
                :
                $utils.convertDollar(
                  summary.data.provision -
                    summary.data.monthly -
                    summary.data.management -
                    summary.data.bounty,
                )
              }}
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="totalPagesSummary > 10" class="p-3">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalPagesSummary"
          :per-page="itemsPerPage"
          :prev-text="$ml.get('previous')"
          :next-text="$ml.get('next')"
          align="right"
        >
        </b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js";
import Swal from "sweetalert2";
import CompanyService from "../../../services/company.service";
import InvoiceService from "../../../services/invoice.service";
import ReportService from "../../../services/report.service";
import { utils } from "../../../utils";

export default {
  name: "payment",
  data() {
    return {
      billingScreen: true,
      rows: 100,
      itemsPerPage: 10,
      currentPage: 1,
      summaryTable: [],
      tabDetailsShow: false,
      page: 1,
      pageSize: 10,
      totalPages: 0,
      sliderValue: 0,
      initialDate: "",
      finalDate: "",
      status: null,
      type: null,
      itensPayment: [],
      loading: true,
      loadingBtn: false,
      invoiceNumberSearch: "",
      reportSearch: "",
      selectedTab: "Summary",
      summaryPayments: [],
      monthly_payment_data: [],
      program_management_payment_data: [],
      bounty_payment_data: [],
      provision_data: [],
      today: new Date(),
      fullYear: null,
      balance_value: 0,
      monthYear: [],
      myChart: null,
      myGaugeChart: null,
      vulnerabilitiesChart: {},
      vulnerabilitiesTotal: 0,
      projected_data_size: 0,
      itensSituation: [
        { id: "", name: "all" },
        { id: "done", name: "done" },
        { id: "pending", name: "pending" },
      ],

      month: [
        "january",
        "february",
        "march",
        "april",
        "may",
        "june",
        "july",
        "august",
        "september",
        "october",
        "november",
        "december",
      ],

      itensType: [
        { id: "", name: "all" },
        { id: "standard", name: "monthlyPayment" },
        { id: "program_management", name: "program_management" },
        { id: "report_payment", name: "Bounties" },
      ],

      total_initial_value: 0,
      total_paid_value: 0,
      total_contract_standard_value: 0,
      total_contract_management_value: 0,
      total_bounty_value: 0,
      balance_percentage: 0,
      provisionsSummary: false,
      currency: "",
      routePath:"",
    };
  },
  watch: {
    initialDate: function () {
      this.dataOrder();
      if (this.finalDate) {
        this.getReportSummary();
      }
    },
    finalDate: function () {
      this.dataOrder();
      if (this.initialDate) {
        this.getReportSummary();
      }
    },
    projected_data_size: function () {
      this.getReportSummary();
    },
    page: function () {
      this.changeDados();
    },
  },
  mounted() {
    this.routePath = this.$route.fullPath
    this.currency = this.$store.getters['getUser']?.currency;
    this.fullYear = this.today.getFullYear();
    this.changeDados();
    this.changeProvisionsSummary();
    this.getReportSummary();
    this.loadChart();
    this.loadData();
  },

  computed: {
    displayedItems() {
      const startIndex = (this.currentPage - 1) * this.itemsPerPage;
      const endIndex = startIndex + this.itemsPerPage;
      return this.summaryTable.slice(startIndex, endIndex);
    },
    totalPagesSummary() {
      return (
        (Math.ceil(this.summaryTable.length / this.itemsPerPage) * 100) / 10
      );
    },
  },
  methods: {
    createVulnChart(vulnerabilities) {
      let series = [];
      let labels = [];
      let colors = [];

      series[0] = vulnerabilities.critical;
      labels[0] = "critical";
      colors[0] = "#E10E71";

      series[1] = vulnerabilities.high;
      labels[1] = "high";
      colors[1] = "#9F2EDC";

      series[2] = vulnerabilities.medium;
      labels[2] = "medium";
      colors[2] = "#6F6FFF";

      series[3] = vulnerabilities.low;
      labels[3] = "low";
      colors[3] = "#636363";

      this.vulnerabilitiesChart = {
        chart: {
          offsetX: -40,
          type: "donut",
        },
        plotOptions: {
          pie: {
            startAngle: -90,
            endAngle: 270,
          },
        },
        labels: labels.filter((n) => n),
        colors: colors.filter((n) => n),
        series: series.filter((n) => n),
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
      };
    },
    async loadData() {
      try {
        const { data } = await ReportService.getSummaryBounties();
        this.createVulnChart(data);
        this.vulnerabilitiesTotal = data.total ?? 0;
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "info",
          title: "",
          text: this.$ml.get("unableToCompleteThisRequest"),
        });
      }
    },
    handleSliderInput() {
      this.projected_data_size = this.sliderValue;
    },
    async getReportSummary() {
      try {
        const { data } = await CompanyService.getReportSummary(
          this.initialDate,
          this.finalDate,
        );
        this.summaryPayments = data;
        this.summaryTable = data;
        this.monthly_payment_data = this.summaryPayments.map(
          (it) => it.data?.monthly,
        );
        this.program_management_payment_data = this.summaryPayments.map(
          (it) => it.data?.management,
        );
        this.bounty_payment_data = this.summaryPayments.map(
          (it) => it.data?.bounty,
        );
        this.provision_data = this.summaryPayments.map(
          (it) => it.data?.provision,
        );

        const year = this.summaryPayments.map((it) => it.year);
        this.fullYear = year[0] ?? this.today.getFullYear();

        this.monthYear = this.summaryPayments.map(({ month, year }) => ({
          month,
          year,
        }));
        this.myChart.destroy();
        this.loadChart();
      } catch (error) {
        console.log(error);
      }
    },
    sortDate(a, b) {
      return a.date - b.date;
    },

    nameLang({ name }) {
      if (!["Bounties"].includes(name)) {
        return this.$ml.get(name) ?? name;
      } else {
        return name;
      }
    },

    sumBounty(itens) {
      let resp = 0;
      itens.forEach((element) => {
        resp += parseFloat(element.bounty_value);
      });
      return resp;
    },

    total(itens, percent) {
      let totalPayments = 0;
      let monthlyPayments = 0;

      itens.report_payments.forEach((element) => {
        totalPayments += parseFloat(element.bounty_value);
      });

      itens.monthly_payments.forEach((element) => {
        monthlyPayments += parseFloat(element.value);
      });

      return totalPayments * ((percent || 0) / 100 + 1) + monthlyPayments;
    },

    sumMonthly(itens) {
      let resp = 0;
      itens.forEach((element) => {
        resp += parseFloat(element.value);
      });
      return resp;
    },

    program_management(itens) {
      let program_management = [];
      program_management = itens.filter(
        (item) => item.type == "program_management",
      );

      return program_management.length ? program_management : false;
    },

    monthlyPayment(itens) {
      let monthly_Payment = [];
      monthly_Payment = itens.filter((item) => item.type == "standard");

      return monthly_Payment.length ? monthly_Payment : false;
    },

    dataOrder() {
      var first = this.initialDate;
      var end = this.finalDate;

      if (first && end) {
        first = first.split("/");
        end = end.split("/");

        first = new Date(first[1] + "-" + first[0] + "-" + first[2]);
        end = new Date(end[1] + "-" + end[0] + "-" + end[2]);

        if (first > end) {
          let invert = this.initialDate;
          this.initialDate = this.finalDate;
          this.finalDate = invert;
        }
        this.changeDados();
      } else {
        this.changeDados();
      }
    },

    searchTime() {
      var self = this;
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(function () {
        self.changeDados();
      }, 1000);
    },

    changeDados() {
      let initial = this.initialDate;

      if (initial) {
        initial = initial.split("/");
        initial = [initial[1], initial[0], initial[2]].join("-");
      }
      let end = this.finalDate;
      if (end) {
        end = end.split("/");
        end = [end[1], end[0], end[2]].join("-");
      }

      let payload = "";

      payload += `page=${this.page}`;
      payload += `&pageSize=${this.pageSize}`;

      if (this.reportSearch) {
        payload += `&report=${this.reportSearch}`;
      }

      if (this.status?.id) {
        payload += `&invoiceStatus=${this.status.id}`;
      }

      if (this.type?.id) {
        payload += `&type=${this.type.id}`;
      }

      if (initial) {
        payload += `&initialDate=${initial}`;
      }

      if (end) {
        payload += `&finalDate=${end}`;
      }
      if (this.invoiceNumberSearch) {
        payload += `&invoiceNumber=${String(this.invoiceNumberSearch)}`;
      }

      this.loading = true;
      this.itensPayment = [];

      InvoiceService.getInvoice(payload).then(
        (response) => {
          this.loading = false;
          this.itensPayment = response.data.items;

          this.itensPayment.forEach((element) => {
            element.report_payments.forEach((element) => {
              (element.type = "bounty"),
                (element.date = new Date(element.payment_requested_at));
            });

            element.monthly_payments.forEach((element) => {
              element.date = new Date(element.limit_date);
            });

            element.extractItem = element.report_payments
              .concat(element.monthly_payments)
              .sort(this.sortDate);
          });
          this.totalPages = response.data.total;
        },
        () => {
          this.loading = false;
        },
      );
    },

    changeProvisionsSummary() {
      CompanyService.getProvisionsSummary().then((response) => {
        let resp = response.data;

        if (
          !resp.balance_value &&
          !resp.total_initial_value &&
          !resp.total_paid_value
        ) {
          this.provisionsSummary = false;
        } else {
          this.provisionsSummary = true;
          this.balance_value = resp.balance_value;
          this.total_initial_value = resp.total_initial_value;
          this.total_contract_standard_value =
            resp.total_contract_standard_value;
          this.total_contract_management_value =
            resp.total_contract_management_value;
          this.total_bounty_value = resp.total_bounty_value;
          this.total_paid_value = resp.total_paid_value;
          this.balance_percentage = Math.round(
            (resp.balance_value * 100) / resp.total_initial_value,
          ).toFixed(1);
        }
        this.loadGaugeChart();
      });
    },

    convertMoney(money) {
      money = parseFloat(money);
      return money.toLocaleString("pt-br", {
        style: "currency",
        currency: "BRL",
      });
    },

    downloadCSVData() {
      this.loadingBtn = true;

      InvoiceService.getPaymentsExport().then(
        (response) => {
          this.loadingBtn = false;

          var headers = {
            number: "Nota Fiscal",
            issued: "Data de emissão",
            payment_date: "Data de pagamento",
            accurate: "Valor Apurado",
            type: "Tipo",
            status: "Estado",
            monthly: "Total das mensalidades",
            additionalServices: "Total serviços adicionais",
            rewards: "Total de recompensas",
            invoiceValue: "Somatório Total",
          };
          var itemsFormatted = [];
          // format the data
          response.data?.items.forEach((item) => {
            let monthly = "";
            let additionalServices = "";
            let rewards = "";
            let invoiceValue = "";

            if (this.monthlyPayment(item.monthly_payments)) {
              monthly = this.currency === 'BRL' ? this.convertMoney(
                this.sumMonthly(this.monthlyPayment(item.monthly_payments)),
              ) : this.$utils.convertDollar(
                this.sumMonthly(this.monthlyPayment(item.monthly_payments)),
              );
            }

            if (this.program_management(item.monthly_payments)) {
              additionalServices = this.currency === 'BRL' ? this.convertMoney(
                this.sumMonthly(this.program_management(item.monthly_payments)),
              ) : this.$utils.convertDollar(
                this.sumMonthly(this.program_management(item.monthly_payments)),
              );
            }

            if (item.report_payments.length) {
              rewards = this.currency === 'BRL' ? this.convertMoney(this.sumBounty(item.report_payments)) : this.$utils.convertDollar(this.sumBounty(item.report_payments));
            }

            invoiceValue =  this.currency === 'BRL' ?  this.convertMoney(this.total(item)) : this.$utils.convertDollar(this.total(item));

            let type = [];

            if (item.report_payments?.length) {
              type.push("Bounties");
            }
            if (this.monthlyPayment(item.monthly_payments)) {
              type.push(this.$ml.get("monthlyPayment"));
            }
            if (this.program_management(item.monthly_payments)) {
              type.push(this.$ml.get("program_management"));
            }

            type = type.join(" - ");

            itemsFormatted.push({
              number: item.number,
              issued: this.$utils.formatDataShort(item.dEmi),
              payment_date:
                item.payment_date != "--/--/----"
                  ? this.$utils.formatDataShort(item.payment_date)
                  : "",
              accurate: this.currency === 'BRL' ? this.convertMoney(item.value) : this.$utils.convertDollar(item.value),
              type: type,
              status: item.status == "pending" ? "Pendente" : "Pago",
              monthly: monthly,
              additionalServices: additionalServices,
              rewards: rewards,
              invoiceValue: invoiceValue,
            });
          });

          itemsFormatted.unshift(headers);

          // Convert Object to JSON
          var jsonObject = JSON.stringify(itemsFormatted);

          var array =
            typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;
          var csv = "";

          for (var i = 0; i < array?.length; i++) {
            var line = "";
            for (var index in array[i]) {
              if (line != "") line += ";";
              line += array[i][index];
            }
            csv += line + "\r\n";
          }

          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download = "payments.csv";
          anchor.click();
        },
        () => {
          this.loadingBtn = false;
        },
      );
    },

    loadChart() {
      let provision_colors = [];
      let monthly_payment_colors = [];
      let bounty_payment_colors = [];
      let program_management_payment_colors = [];

      let estimated_cost_data = [];

      //testing transparency for projected data
      // amount of months that should be projected
      let projectedData = this.monthYear ?? [];

      for (let index = 1; index <= this.projected_data_size; index++) {
        const last_projected_data = projectedData[projectedData.length - 1];

        const new_month =
          last_projected_data.month == 12 ? 1 : last_projected_data.month + 1;

        const new_year =
          last_projected_data.month != 12
            ? last_projected_data.year
            : last_projected_data.year + 1;

        projectedData = [
          ...projectedData,
          {
            month: new_month,
            year: new_year,
          },
        ];
      }
      //provision
      const last_provision_value =
        this.provision_data[this.provision_data?.length - 1];
      provision_colors = new Array(this.provision_data.length).fill("#9EA4DB");
      for (let index = 0; index <= this.projected_data_size; index++) {
        this.provision_data = [...this.provision_data, last_provision_value];
        provision_colors.push("#9EA4DB70");
      }

      //monthly payment
      const monthly_payment_value =
        this.monthly_payment_data.length > 0
          ? this.monthly_payment_data[this.monthly_payment_data.length - 1] -
            this.monthly_payment_data[this.monthly_payment_data.length - 2]
          : this.monthly_payment_data[0];

      monthly_payment_colors = new Array(
        this.monthly_payment_data?.length,
      ).fill("#9F2EDC");

      for (let index = 0; index <= this.projected_data_size; index++) {
        const element =
          this.monthly_payment_data[this.monthly_payment_data?.length - 1];
        this.monthly_payment_data.push(element + monthly_payment_value);
        monthly_payment_colors.push("#9F2EDC70");
      }

      //bounty payment
      const bounty_payment_value =
        this.bounty_payment_data.length > 0
          ? this.bounty_payment_data[this.bounty_payment_data?.length - 1] -
            this.bounty_payment_data[this.bounty_payment_data?.length - 2]
          : this.bounty_payment_data[0];

      bounty_payment_colors = new Array(this.bounty_payment_data?.length).fill(
        "#C585E9",
      );

      for (let index = 0; index <= this.projected_data_size; index++) {
        const element =
          this.bounty_payment_data[this.bounty_payment_data?.length - 1];
        // this.bounty_payment_data.push(element + bounty_payment_value);
        this.bounty_payment_data = [
          ...this.bounty_payment_data,
          element + bounty_payment_value,
        ];

        bounty_payment_colors.push("#C585E950");
      }

      //program management payment
      const program_management_payment_value =
        this.program_management_payment_data.length > 0
          ? this.program_management_payment_data[
              this.program_management_payment_data?.length - 1
            ] -
            this.program_management_payment_data[
              this.program_management_payment_data?.length - 2
            ]
          : this.program_management_payment_data[0];

      program_management_payment_colors = new Array(
        this.program_management_payment_data?.length,
      ).fill("#B560E4");

      for (let index = 0; index <= this.projected_data_size; index++) {
        const element =
          this.program_management_payment_data[
            this.program_management_payment_data?.length - 1
          ];
        this.program_management_payment_data.push(
          element + program_management_payment_value,
        );
        program_management_payment_colors.push("#B560E450");
      }

      //end of transparency for projected data test
      for (let index = 0; index < this.provision_data?.length; index++) {
        const element = this.provision_data[index];

        estimated_cost_data[index] =
          (this.monthly_payment_data[index] ?? 0) +
          (this.bounty_payment_data[index] ?? 0) +
          (this.program_management_payment_data[index] ?? 0);

        this.provision_data[index] = (
          element - estimated_cost_data[index]
        ).toFixed(2);
      }

      const monthFullYear = projectedData.map(
        (it) => `${this.$ml.get(this.month[it.month - 1])} ${it.year}`,
      );
      var options = {
        type: "bar",
        data: {
          barPercentage: 1.0,

          labels:
            this.monthYear.length > 1
              ? monthFullYear
              : [
                  `${this.$ml.get("january")} ${this.fullYear}`,
                  `${this.$ml.get("february")} ${this.fullYear}`,
                  `${this.$ml.get("march")} ${this.fullYear}`,
                  `${this.$ml.get("april")} ${this.fullYear}`,
                  `${this.$ml.get("may")} ${this.fullYear}`,
                  `${this.$ml.get("june")} ${this.fullYear}`,
                  `${this.$ml.get("july")} ${this.fullYear}`,
                  `${this.$ml.get("august")} ${this.fullYear}`,
                  `${this.$ml.get("september")} ${this.fullYear}`,
                  `${this.$ml.get("october")} ${this.fullYear}`,
                  `${this.$ml.get("november")} ${this.fullYear}`,
                  `${this.$ml.get("december")} ${this.fullYear}`,
                  `${this.$ml.get("january")} ${this.fullYear + 1}`,
                  `${this.$ml.get("february")} ${this.fullYear + 1}`,
                  `${this.$ml.get("march")} ${this.fullYear + 1}`,
                  `${this.$ml.get("april")} ${this.fullYear + 1}`,
                  `${this.$ml.get("may")} ${this.fullYear + 1}`,
                  `${this.$ml.get("june")} ${this.fullYear + 1}`,
                  `${this.$ml.get("july")} ${this.fullYear + 1}`,
                  `${this.$ml.get("august")} ${this.fullYear + 1}`,
                  `${this.$ml.get("september")} ${this.fullYear + 1}`,
                  `${this.$ml.get("october")} ${this.fullYear + 1}`,
                  `${this.$ml.get("november")} ${this.fullYear + 1}`,
                  `${this.$ml.get("december")} ${this.fullYear + 1}`,
                  `${this.$ml.get("january")} ${this.fullYear + 2}`,
                  `${this.$ml.get("february")} ${this.fullYear + 2}`,
                  `${this.$ml.get("march")} ${this.fullYear + 2}`,
                  `${this.$ml.get("april")} ${this.fullYear + 2}`,
                  `${this.$ml.get("may")} ${this.fullYear + 2}`,
                  `${this.$ml.get("june")} ${this.fullYear + 2}`,
                  `${this.$ml.get("july")} ${this.fullYear + 2}`,
                  `${this.$ml.get("august")} ${this.fullYear + 2}`,
                  `${this.$ml.get("september")} ${this.fullYear + 2}`,
                  `${this.$ml.get("october")} ${this.fullYear + 2}`,
                  `${this.$ml.get("november")} ${this.fullYear + 2}`,
                  `${this.$ml.get("december")} ${this.fullYear + 2}`,
                ],
          datasets: [
            {
              type: "line",
              label: this.$ml.get("costProjection"),
              backgroundColor: "#E10E71",
              borderColor: "#E10E71",
              data: estimated_cost_data,
              fill: false,
            },
            {
              label: this.$ml.get("monthlyPayment"),
              backgroundColor: monthly_payment_colors,
              data: this.monthly_payment_data,
            },
            {
              label: this.$ml.get("managed"),
              backgroundColor: program_management_payment_colors,
              data: this.program_management_payment_data,
            },
            {
              label: this.$ml.get("rewards"),
              backgroundColor: bounty_payment_colors,
              data: this.bounty_payment_data,
            },
            {
              label: this.$ml.get("contributionBalance"),
              backgroundColor: provision_colors,
              data: this.provision_data,
            },
          ],
        },
        options: {
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                return `${data.datasets[tooltipItem.datasetIndex].label} ${this.currency === 'BRL' ? utils.convertMoney(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]) : utils.convertDollar(data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index])}`;
              },
            },
          },

          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 5,
              right: 5,
              top: 5,
              bottom: 5,
            },
          },
          scales: {
            scaleShowValues: true,
            xAxes: [
              {
                stacked: true,
                // scaleLabel: {
                //   display: true,
                //   labelString: "also random",
                // },
                ticks: {
                  autoSkip: false,
                },
                gridLines: {
                  display: true,
                },
              },
            ],
            yAxes: [
              {
                stacked: true,
                // scaleLabel: {
                //   display: true,
                //   labelString: "R$",
                // },
                gridLines: {
                  display: true,
                },
              },
            ],
          },
          // title: {
          //   display: true,
          //   text: "title",
          // },
        },
      };

      var ctx = document.getElementById("chart-main").getContext("2d");
      this.myChart = new Chart(ctx, options);
    },

    loadGaugeChart() {
      var options = {
        type: "doughnut",
        data: {
          labels: ["Total pago", "Saldo"],
          datasets: [
            {
              label: "",
              data: [
                this.total_initial_value - this.balance_value,
                this.balance_value,
              ],
              backgroundColor: ["#720CA2", "#E10E71"],
              borderWidth: 0.5,
              borderColor: "#00000070",
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: {
              left: 0,
              right: 10,
              top: 10,
              bottom: 20,
            },
          },
          cutoutPercentage: 55,
          circumference: 1.5 * Math.PI,
          rotation: 7.85,
          legend: {
            display: false,
          },
          aspectRatio: 1,
        },
      };

      var ctx = document.getElementById("custom-gauge-chart");
      this.myGaugeChart = new Chart(ctx, options);
    },
  },
};
</script>
<style lang="scss">
.reportItem:nth-child(odd) {
  background: rgba(255, 255, 255, 0.522);
}

/* Chrome e outros */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.angle-right {
  -ms-transform: rotate(90deg);
  /* IE 9 */
  transform: rotate(90deg);
}

.collapsed .when-opened {
  -ms-transform: rotate(270deg);
  /* IE 9 */
  transform: rotate(270deg);
}
.text-summary {
  a,
  b {
    line-height: 1.3rem;
  }
}
.base-card {
  margin-right: 10px;
  position: relative;
  border-radius: 9px;
  background: #5f1b72;
  height: 120px;
  padding: 0px 10px;
  margin-bottom: 1rem;
  color: #f8f8f8;
  min-width: 230px;
  .area-label {
    margin-bottom: 10px;
    position: absolute;
    top: 48%;
    right: 5%;
    text-align: right;
    label {
      font-weight: 500;
      color: #ecececbb;
      font-size: 1rem;
      margin: 0px;
      padding: 0px;
      white-space: nowrap;
    }
    span {
      font-size: 1.5rem;
      font-weight: 500;
      white-space: nowrap;
      color: #fafafa;
    }
  }
  .base-logo {
    position: relative;
    top: 1rem;
  }
  .gauge-chart {
    position: absolute;
    right: 5.8rem;
    bottom: 0;
  }
  .gauge-percentage {
    font-size: 0.9rem;
    color: white;
    font-weight: 500;
    position: absolute;
    margin-top: 3rem;
    margin-left: -1.3rem;
  }
}
.gauge-chart {
  text-align: center;
  // background: red;
  label {
    font-weight: 500;
    color: #ecececbb;
    font-size: 1rem;
    margin: 0px;
    padding: 0px;
    white-space: nowrap;
  }
}
.custom-range {
  box-shadow: none;
}
.custom-range::-webkit-slider-thumb {
  background-color: #720ca2;
  border: 2px solid #720ca2;
  height: 20px;
  width: 20px;
}
.gauge-chart {
  min-width: 200px;
  max-width: 240px;
  height: 120px;
}
.c-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  justify-content: space-between;
}
@media (max-width: 1560px) {
  .c-grid {
    grid-template-columns: repeat(3, 260px);
  }
}
@media (max-width: 948px) {
  .c-grid {
    grid-template-columns: repeat(2, 260px);
  }
}
</style>
